module.exports = __webpack_public_path__ + "media/packs/images/flags/BD-2e7e41127e286c11d23b447720bfc603.png";